import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Strategy from './Strategy';
import reportWebVitals from './reportWebVitals';
import {UtilityProvider} from './utility-provider'
import {UserProvider} from './user-provider'
import Login from './Login'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <UserProvider>
      <Login url={window.location.href}>
        <UtilityProvider>
          <Strategy />
        </UtilityProvider>
      </Login>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
